import { Injectable } from "@angular/core";
import { UserProvider } from "./user";
@Injectable()
export class MenuProvider {
    private _commonPages: Array<any> = [];
    private _contactPages: Array<any> = [];
    private _userPages: Array<any> = [];
    private _logoutPages: Array<any> = [];
    private _homeLinks: Array<any> = [];
    private _activityLinks: Array<any> = [];
    private _tabsLinks: Array<any> = [];
    private _myPractices: any = false;

    /*
        restrict: Boolean - Requer usuário logado!
        type: String - Tipo de Usuário
        children: Array<any> - Se torna submenu para as rotas em children
        mobileOnly: Mostra somente no menu do dispositivo
    */

    constructor(private user: UserProvider) {
        this._commonPages = [
            {
                status: true,
                icon: "calendar-full",
                title: "Reserva de Atividade",
                component: "MenuAtividadesPage",
                type: null,
                restrict: true,
            },
            {
                status: true,
                icon: "place",
                title: "Reserva de Espaços",
                component: "ReservarEspacosPage",
                type: null,
                restrict: true,
            },
            {
                status: true,
                icon: "place",
                title: "Entre no Jogo!",
                component: "EntreNoJogoPage",
                type: null,
                restrict: true,
            },
           /*  {
                status: true,
                icon: "gym-alter",
                title: "Meus treinos",
                component: "MeusTreinosHomePage",
                type: null,
                restrict: true,
                mobileOnly: true,
                training: true,
            }, */
            {
                status: true,
                icon: "map",
                title: "Mapa do Clube",
                component: "MapaInterativoPage",
                type: null,
                restrict: true,
                mobileOnly: true,
            },
            {
                status: true,
                icon: "voucher",
                title: "Compra de Ingressos",
                component: "IngressosPage",
                params: { with: true },
                type: null,
                restrict: true,
            },
            {
                status: true,
                icon: "voucher",
                title: "Compra de Ingressos",
                component: "IngressosPage",
                params: { with: true },
                type: null,
                restrict: false,
            },
            {
                status: true,
                icon: "rise-up",
                title: "Contratação de Serviços",
                component: "ServicosPage",
                type: null,
                restrict: true,
            },
            {
                status: true,
                icon: "list-full",
                title: "Eventos",
                component: "IngressosPage",
                type: null,
                restrict: true,
            },
            // { status: true, icon: 'newspaper', title: 'Notícias', component: '', type: null, restrict: true },
            {
                status: true,
                icon: "question",
                title: "Dúvidas Frequentes",
                component: "DuvidasFrequentesPage",
                type: null,
                restrict: true,
                mobileOnly: true,
            },
            {
                status: true,
                icon: "chat",
                title: "Fale Conosco",
                component: "ContatoPage",
                type: null,
                restrict: true,
                mobileOnly: true,
            },
            {
                status: true,
                icon: "money",
                title: "Pagamentos",
                component: "PagamentosPage",
                type: null,
                restrict: true,
            },
        ];
        this._userPages = [
            {
                status: true,
                title: "Meus Dados",
                component: "MinhasInformacoesPage",
                type: null,
                restrict: true,
            },
            {
                status: true,
                title: "Convênios",
                component: "CartaApresentacaoPage",
                type: null,
                restrict: true,
            },
            {
                status: true,
                title: "Meus Ingressos",
                component: "MeusIngressosPage",
                type: "Associado",
                restrict: true,
            },
            {
                status: true,
                title: "Dependentes",
                component: "DependentesPage",
                type: "Associado",
                restrict: true,
            },
            {
                status: true,
                title: "Minhas Reservas",
                component: "MinhasReservasPage",
                type: null,
                restrict: true,
            },
            {
                status: true,
                title: "Lista de Chamada",
                component: "ListaDePresencaPage",
                type: "Professor",
                restrict: true,
            },
            {
                status: true,
                title: "Lista de Espera",
                component: "ListaDeEsperaPage",
                type: null,
                restrict: true,
            },
            {
                status: true,
                title: "Serviços Contratados",
                component: "ServicosContratadosPage",
                type: null,
                restrict: true,
            },
        ];
        this._logoutPages = [
            { title: "Sair", component: null, type: null, restrict: true },
        ];
        this._activityLinks = [
            {
                status: true,
                icon: "gym",
                title: "Ginástica",
                component: "ReservarAcademiaPage",
                type: null,
                restrict: true,
            },
            {
                status: true,
                icon: "tennis",
                title: "Quadras",
                component: "ReservarQuadrasPage",
                type: null,
                restrict: true,
            },
            {
                status: true,
                icon: "swim",
                title: "Natação",
                component: "ReservarPiscinasPage",
                type: null,
                restrict: true,
            },
            {
                status: true,
                icon: "sport",
                title: "Esportes Radicais",
                component: "ReservarEscolinhasPage",
                type: null,
                restrict: true,
            },
        ];
        this._homeLinks = [
            {
                status: true,
                icon: "calendar-full",
                title: "Reserva de Atividade",
                component: "MenuAtividadesPage",
                type: null,
            },
            {
                status: true,
                icon: "place",
                title: "Reserva de Espaços",
                component: "ReservarEspacosPage",
                type: null,
            },
            {
                status: true,
                icon: "place",
                title: "Minhas Reservas",
                component: "MinhasReservasPage",
                type: null,
            },
            {
                status: true,
                icon: "voucher",
                title: "Compra de Ingressos",
                component: "IngressosPage",
                params: {
                    with: true,
                },
                type: null,
            },
            {
                status: true,
                icon: "rise-up",
                title: "Contratação de Serviços",
                component: "ServicosPage",
                type: null,
            },
            {
                status: true,
                icon: "payment",
                title: "Pagamentos",
                component: "PagamentosPage",
                type: null,
            },
        ];
        this._tabsLinks = [
            {
                title: "Mapa do Clube",
                // popover: true,
                // popoverLinks: [
                //     {
                //         label: 'Sede Juventude',
                //         component: 'MapaInterativoPage'
                //     },
                //     {
                //         label: 'Sede Guarany (Em Breve)',
                //         component: 'MapaInterativoPage'
                //     }
                // ],
                component: "MapaInterativoPage",
                status: true,
                icon: "map",
                type: null,
            },
            {
                title: "Reserva de Atividades",
                component: "MenuAtividadesPage",
                popover: false,
                status: true,
                icon: "calendar-full",
                type: null,
            },
        ];
        this._contactPages = [
            {
                status: true,
                icon: "question",
                title: "Dúvidas Frequentes",
                component: "DuvidasFrequentesPage",
                type: null,
                restrict: true,
            },
            {
                status: true,
                icon: "chat",
                title: "Fale Conosco",
                component: "ContatoPage",
                type: null,
                restrict: true,
            },
        ];
    }

    public async getPages(withContacts: boolean = true) {
        return await this.user.get().then((userData) => {
            let pages = this._commonPages.filter((item) => {
                return this.filterPage(item, userData);
            });
            if (withContacts) {
                let contactPages = this._contactPages.filter((item) => {
                    return this.filterPage(item, userData);
                });
                return pages.concat(contactPages);
            }
            return pages;
        });
    }

    public async getContactPages() {
        return await this.user.get().then((userData) => {
            let pages = this._contactPages.filter((item) => {
                return this.filterPage(item, userData);
            });
            return pages;
        });
    }

    public async getHomeLinks() {
        return await this.user.get().then((userData) => {
            let pages = this._homeLinks.filter((item) => {
                return this.filterPage(item, userData);
            });
            return pages;
        });
    }

    public async getActivityLinks() {
        return await this.user.get().then((userData) => {
            let pages = this._activityLinks.filter((item) => {
                return this.filterPage(item, userData);
            });
            return pages;
        });
    }

    public async getUserPages(withLogout: boolean = true) {
        return await this.user.get().then((userData) => {
            let pages = this._userPages.filter((item) => {
                return this.filterPage(item, userData);
            });
            if (withLogout) {
                let logoutPages = this._logoutPages.filter((item) => {
                    return this.filterPage(item, userData);
                });
                return pages.concat(logoutPages);
            }
            return pages;
        });
    }

    public async getTabs() {
        return await this.user.get().then((userData) => {
            let pages = this._tabsLinks.filter((item) => {
                return this.filterPage(item, userData);
            });

            return pages;
        });
    }

    public filterPage(menuItem: any, userData: any) {
        // Se usuário não está logado
        if (!userData.level) {
            return !menuItem.restrict;
        } else if (menuItem.restrict === false) {
            return false;
        }
        if (menuItem.type == null) {
            return true;
        }
        if (menuItem.type == "Associado") {
            return userData.level == "Associado";
        }
        if (menuItem.type == "Dependente") {
            return userData.level == "Dependente";
        }
        if (menuItem.type == "Professor") {
            return userData.instructor;
        }
        return false;
    }

    public getPolitic() {
        return {
            status: true,
            title: "Política de Privacidade",
            component: "PoliticaPage",
            type: null,
            restrict: true,
        };
    }
}



// WEBPACK FOOTER //
// ./src/providers/menu.ts